import { Injectable } from '@angular/core';
import { PDFFormType } from '@models/matter-form-data';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './form-data.actions';

@Injectable({
	providedIn: 'root',
})
export class MatterFormDataDispatch {
	@Dispatch()
	// rome-ignore lint/suspicious/noExplicitAny: <explanation>
	SetField = (
		id: string,
		type: PDFFormType,
		name: string,
		url: string,
		field: string,
		value: any,
	): actions.SetField =>
		new actions.SetField({ id, type, name, url, field, value });
}
